import * as React from 'react';
import { useSearchParams } from 'react-router-dom';
import ClickableOpacity from '@hero/ui-kit/inputs/ClickableOpacity';
import P from '@hero/ui-kit/typography/P';
import * as Style from './style.module.scss';

const LeadsFilter: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const setQueryFilterType = (value: string) => {
        setSearchParams((searchParams) => {
            searchParams.set('filter_type', value);
            searchParams.delete('offset');

            return searchParams;
        });
    };

    const tabs = React.useMemo(() => {
        const filterType = searchParams.get('filter_type');

        return [
            {
                value: 'default',
                label: 'All Form fills',
                isActive: filterType === 'default' || !filterType
            },
            {
                value: 'expiring_leads',
                label: 'Expiring',
                isActive: filterType === 'expiring_leads'
            }
        ];
    }, [searchParams]);

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '2.8rem',
                minHeight: '4rem'
            }}
        >
            {tabs.map((tab) => (
                <ClickableOpacity
                    key={tab.value}
                    alt={`Set ${tab.value} filter`}
                    onClick={() => setQueryFilterType(tab.value)}
                >
                    <P
                        noDefaultMargin
                        strong
                        className={`${Style.btn} ${tab.isActive ? Style.active : ''}`}
                    >
                        {tab.label}
                    </P>
                </ClickableOpacity>
            ))}
        </div>
    );
};

export default LeadsFilter;
